// src/hooks/useLanguage.ts
import { useState, useEffect } from 'react';
import { translations, Translation } from '@/lib/translations';

export type Language = 'en' | 'th';

export const useLanguage = () => {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('medgaugex-language') as Language | null;
    if (saved === 'en' || saved === 'th') return saved;

    const userLang = navigator.language.toLowerCase();
    const isThaiUser =
      userLang.includes('th') ||
      Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Bangkok';

    // ✅ คืนค่าเป็นคีย์ที่ translations รองรับเท่านั้น
    return isThaiUser ? 'th' : 'en';
  });

  // ✅ กัน null/fallback เสมอ
  const t: Translation = translations[language] ?? translations.en;

  const toggleLanguage = () => {
    const newLang: Language = language === 'en' ? 'th' : 'en';
    setLanguage(newLang);
    localStorage.setItem('medgaugex-language', newLang);
    // ถ้าอยาก reload ก็ได้ แต่ไม่จำเป็น:
    window.location.reload();
  };

  const setLanguageDirectly = (lang: Language) => {
    setLanguage(lang);
    localStorage.setItem('medgaugex-language', lang);
  };

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return { language, t, toggleLanguage, setLanguage: setLanguageDirectly, isEnglish: language === 'en', isThai: language === 'th' };
};
